import { render, staticRenderFns } from "./WetSignSecondary.vue?vue&type=template&id=ef6cf542&"
import script from "./WetSignSecondary.vue?vue&type=script&lang=js&"
export * from "./WetSignSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports